import React from 'react';
import { Shield, Lock, AlertCircle } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="n1-footer">
      <div className="footer-container">
        <div className="footer-trust-badges">
          <div className="trust-badge">
            <AlertCircle size={32} />
            <span>18+</span>
          </div>
          <div className="trust-badge">
            <Lock size={32} />
            <span>SSL Verschlüsselt</span>
          </div>
          <div className="trust-badge">
            <Shield size={32} />
            <span>Verantwortungsbewusstes Spielen</span>
          </div>
        </div>

        <div className="footer-licenses">
          <p>Lizenziert und Reguliert</p>
          <p className="license-text">
            N1 Casino und N1 Bet sind von renommierten Glücksspielbehörden lizenziert und reguliert.
            Alle Spiele werden regelmäßig auf Fairness geprüft.
          </p>
        </div>

        <div className="footer-disclaimer">
          <p>
            <strong>Wichtiger Hinweis:</strong> Glücksspiel kann süchtig machen. Spielen Sie verantwortungsbewusst.
            Nur für Personen über 18 Jahre.
          </p>
          <div className="footer-responsible-logos">
            <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer">
              <img src="https://contentdeliverynetwork.cc/n1bet/logos/responsibility/white/responsiblegaming.svg" alt="GamCare" />
            </a>
            <a href="https://gamblingtherapy.org/" target="_blank" rel="noopener noreferrer">
              <img src="https://contentdeliverynetwork.cc/n1bet/logos/responsibility/white/gambling_therapy.svg" alt="Gambling Therapy" />
            </a>
            <a href="https://gamblersanonymous.org.uk/" target="_blank" rel="noopener noreferrer">
              <img src="https://contentdeliverynetwork.cc/n1bet/logos/responsibility/white/gamblers_anonymous.svg" alt="Gamblers Anonymous" />
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 N1 Casino. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
